import { render } from "./AntiSlavery.vue?vue&type=template&id=2a465fb4&scoped=true"
import script from "./AntiSlavery.vue?vue&type=script&lang=js"
export * from "./AntiSlavery.vue?vue&type=script&lang=js"

import "./AntiSlavery.vue?vue&type=style&index=0&id=2a465fb4&scoped=true&lang=scss"
import "./AntiSlavery.vue?vue&type=style&index=1&id=2a465fb4&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a465fb4"]])

export default __exports__